import { render, staticRenderFns } from "./NotificationAdd.vue?vue&type=template&id=8c390f94&scoped=true&"
import script from "./NotificationAdd.vue?vue&type=script&lang=js&"
export * from "./NotificationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c390f94",
  null
  
)

export default component.exports